"use strict";

// Side-effect imports, same shape as easy-pick-blocked.js's
// `import '../libs/local/easypick/index.bab.js'`. Define window.KzmCal and
// window.KzmCalAvailability. Adjust the paths to wherever they land in the bundle.
import '../libs/local/kzmCal/KzmCal.min.js';
import '../libs/local/kzmCal/KzmCalAvailability.min.js';
import {closeEntry} from "./hashRouter";

// The calendar's wording, read off `data-i18n` on the container instead of a
// German/English table compiled into this bundle. See kzm-i18n.js.
import { readI18n, readLocale } from '../libs/local/kzmCal/kzm-i18n.min.js';

import $ from "jquery";

/*
 * detail-search-bar.js — KzmCal edition.
 *
 * Merges the two modules the property detail page used to load:
 *   current_src/detail-search-bar-old.js  booking-box chrome (kept as-is)
 *   easy-pick-blocked.js                  the easepick date-range driver (replaced)
 *
 * Same shape as portal-search-bar.js does for the start page, and for the same
 * reason: this file *is* `web/static/js/scripts/detail-search-bar.js`, the module
 * `_config.detailSearch` switches on. Keeping the chrome anywhere else means the
 * next deploy of the calendar silently deletes it — which is exactly what
 * happened once already, taking the persons +/- counters, the price-type toggle,
 * the field highlight and the whole mobile pull-up with it.
 *
 * The calendar half drives two pickers: the desktop one, which lives permanently
 * inline in `#ep-desktop-inline` far below its from/to fields, and the mobile one
 * inside `.portal-search-mobile-pullup`.
 *
 * What this page adds over the start page (`portal-search-bar.js`):
 *   - real availability, fetched from `data-avail-url`
 *   - a live server preselection in the hidden inputs
 *   - price recalculation into `data-recalc-target`, plus the watchlist button
 *   - a page scroll to the calendar instead of a dropdown
 *
 * See BLOCKED-PORT-NOTES.md and compare/report.md for how the two differ and
 * which of the original's behaviours were deliberately not reproduced.
 */

/* ========================================================================
 * Calendar — replaces easy-pick-blocked.js
 * ====================================================================== */

// easepick's LockPlugin.maxDays — KzmCal's `maxNights`, same night count.
var KZM_MAX_DAYS = 365;
var KZM_MIN_DATE = "2024-07-16";
// The original hard-codes both: the scroll lands the calendar's block 138px
// from the top of the viewport, and the mobile pull-up jumps 220px short of the
// day it is seeking so the sticky header does not cover it.
var SCROLL_BLOCK_OFFSET = 90 + 48;
var MOBILE_JUMP_OFFSET = 220;

function initCalendars($scope) {
    var mobileBreakpointXs = 768;

    $scope.find(".js-easypicker-container").each(function () {
        var myself = $(this);
        if (myself.hasClass("initialized")) {
            return true;
        }

        // No availability URL means this is not a property-page container —
        // leave it to whichever module owns it.
        if (!myself.data("avail-url")) {
            return true;
        }
        myself.addClass("initialized");

        var ismobile = myself.data("ismobile") === 1;
        // Locale and blocked-cell wording both come off the container: the tag
        // from `data-locale`, the words from `data-i18n`, which Twig fills from
        // Pimcore. See kzm-i18n.js.
        var lang = readLocale(myself);
        var t = readI18n(myself, lang);

        // data-min-duration is already a night count. The original converted it
        // to easepick's day count (`minDays = data + 1`) and converted back for
        // display; KzmCal counts nights, so it is used as-is.
        var minNights = parseInt(myself.data("min-duration"), 10);
        if (!minNights || minNights < 0) {
            minNights = 29;
        }
        // data-max-duration is empty on every object seen so far; the original
        // ignored it entirely and hard-coded 365.
        var maxDays = parseInt(myself.data("max-duration"), 10) || KZM_MAX_DAYS;

        var dateFromContEl = myself.find(".easypick-from-container");
        var dateToContEl = myself.find(".easypick-to-container");
        var dateFromEl = dateFromContEl.find(".easypick-from");
        var dateToEl = dateToContEl.find(".easypick-to");
        var dateFromHiddenEl = dateFromContEl.find(".easypick-from__hidden");
        var dateToHiddenEl = dateToContEl.find(".easypick-to__hidden");
        var dateFromCloseEl = dateFromContEl.find(".easypick-close");
        var dateToCloseEl = dateToContEl.find(".easypick-close");

        var nightsCont = myself.find(".nights-container");
        var nightsEl = nightsCont.find(".nights-val");

        var showAllEl = myself.find(".mobile-search-someinfo");
        var showAllElSpan = showAllEl.find("span:first");
        var showAllElPh = showAllElSpan.data("placeholder");

        /* ----- mount -------------------------------------------------- */
        /*
         * Desktop points `data-wrapper-target` at `#ep-desktop-inline`, a block
         * that sits far below the fields and is *always* visible — there is no
         * dropdown and no outside-click close on this page. The mount goes
         * inside `.js-easypick-wrapper-inner` so the site's own
         * `.easypick-loading-overlay`, which is absolutely positioned against
         * that element, still covers the calendar.
         *
         * Mobile has no wrapper target; the mount goes directly after the
         * sticky header, ahead of the two d-none position inputs.
         */
        var wrapperTarget = myself.data("wrapper-target");
        var jsEpWrapper = wrapperTarget ? $(wrapperTarget) : $();
        var hasTarget = jsEpWrapper.length > 0;
        var mountEl = $('<div class="js-kzm-cal-mount"></div>');

        if (hasTarget) {
            // `.kzm-cal` is a block and this wrapper is the full column width,
            // so without this the card would stretch instead of centring the
            // way easepick's own wrapper did.
            mountEl.addClass("is-inline");
            var innerEl = jsEpWrapper.find(".js-easypick-wrapper-inner");
            mountEl.appendTo(innerEl.length > 0 ? innerEl : jsEpWrapper);
        } else {
            var stickyWrapper = myself.find(".mobile-search-fromto-wrapper");
            if (stickyWrapper.length > 0) {
                mountEl.insertAfter(stickyWrapper);
            } else {
                mountEl.appendTo(myself);
            }
            jsEpWrapper = mountEl.parent();
        }

        // The block the from/to fields scroll the page to. Desktop only —
        // mobile scrolls the pull-up instead.
        var scrollToBlock = jsEpWrapper.closest(".objekt-detail-block");

        var calendarsNr = 2;
        var gridNr = 2;
        if (ismobile) {
            calendarsNr = 6;
            gridNr = screen.width >= mobileBreakpointXs ? 2 : 1;
        }

        var footerInfoStr = "";
        if (!ismobile) {
            // Mobile carries a hard-coded .footer-info in its own markup.
            footerInfoStr = myself.data("footer-info") || "";
            footerInfoStr = footerInfoStr.replace(
                "%minNights%",
                '<span class="min-nights">' + minNights + "</span>"
            );
        }

        /* ----- value formatting --------------------------------------- */
        var monthFmt = new Intl.DateTimeFormat(lang, { month: "short" });

        // easepick used the literal format "D. MMM. YYYY" for every language,
        // so the separators must not come from the locale.
        var formatDisplay = function (isoStr) {
            if (!isoStr) {
                return "";
            }
            var parts = isoStr.split("-");
            var d = new Date(+parts[0], +parts[1] - 1, +parts[2]);
            return d.getDate() + ". " + monthFmt.format(d) + ". " + d.getFullYear();
        };

        // The trailing time is required: the site's search reads these hidden
        // fields and its date handling breaks on a bare YYYY-MM-DD. The server
        // renders the `to` field as T23:59:59, but the original always wrote
        // back T00:00:00 — verified live — so that is what we write too.
        var formatHidden = function (isoStr) {
            return isoStr ? isoStr + "T00:00:00" : "";
        };

        // The hidden inputs arrive as `2026-08-20T00:00:00`; take the date part.
        var isoFromHidden = function (val) {
            if (!val) {
                return null;
            }
            var m = String(val).match(/^(\d{4}-\d{2}-\d{2})/);
            return m ? m[1] : null;
        };

        /* ----- input plumbing ----------------------------------------- */
        var currDateFrom = isoFromHidden(dateFromHiddenEl.val());
        var currDateTo = isoFromHidden(dateToHiddenEl.val());

        var updateSomeInfo = function () {
            if (!ismobile) {
                return;
            }
            var dateFromStr = dateFromEl.val();
            var dateToStr = dateToEl.val();
            if (dateFromStr && dateToStr) {
                showAllElSpan.text(dateFromStr + " - " + dateToStr);
            } else if (dateFromStr) {
                showAllElSpan.text(dateFromStr + " - ");
            } else {
                showAllElSpan.text(showAllElPh);
            }
        };

        var setDateFromEls = function (isoStr) {
            currDateFrom = isoStr;
            dateFromCloseEl.removeClass("hidden").css("display", "");
            dateFromEl.val(formatDisplay(isoStr));
            dateFromEl.trigger("change");
            dateFromHiddenEl.val(formatHidden(isoStr));
        };
        var clearDateFromEls = function () {
            currDateFrom = null;
            dateFromCloseEl.addClass("hidden");
            dateFromEl.val("");
            dateFromEl.trigger("change");
            dateFromHiddenEl.val("");
        };
        var setDateToEls = function (isoStr) {
            currDateTo = isoStr;
            dateToCloseEl.removeClass("hidden").css("display", "");
            dateToEl.val(formatDisplay(isoStr));
            dateToEl.trigger("change");
            dateToHiddenEl.val(formatHidden(isoStr));
        };
        var clearDateToEls = function () {
            currDateTo = null;
            dateToCloseEl.addClass("hidden");
            dateToEl.val("");
            dateToEl.trigger("change");
            dateToHiddenEl.val("");
        };

        /*
         * Unlike the start page, preselection here is live: the server fills
         * both hidden inputs and the desktop visible ones. Mobile's visible
         * inputs are served empty, so paint them from the hidden values to
         * match what the original did on init.
         */
        var initialRange = (currDateFrom && currDateTo && currDateTo > currDateFrom)
            ? { from: currDateFrom, to: currDateTo }
            : null;
        if (initialRange) {
            setDateFromEls(initialRange.from);
            setDateToEls(initialRange.to);
        } else {
            clearDateFromEls();
            clearDateToEls();
        }
        nightsCont.hide();
        updateSomeInfo();

        /* ----- the picker --------------------------------------------- */
        var cal = new KzmCal({
            mount: mountEl[0],
            containerClass: "kzm-cal-panel",
            locale: lang,
            nightsLocale: t.nights,
            minStayLabel: t.minStay,
            maxStayLabel: t.maxStay,
            unavailableLabel: t.unavailable,
            departureOnlyLabel: t.departureOnly,
            minNights: minNights,
            // Stands in for easepick's LockPlugin.maxDays. A check-out further
            // out than this is blocked and the hover pill says why, the way the
            // min-stay days do.
            maxNights: maxDays,
            minDate: KZM_MIN_DATE,
            calendars: calendarsNr,
            footerInfoHTML: footerInfoStr,
            rangeTooltip: true,
            /*
             * `blocked` is the list of blocked nights and the only thing the
             * endpoint sends: the check-out days and the min-stay projection
             * are derived from those nights plus minNights. See
             * KzmCalAvailability.js and compare/report.md §4.
             */
            availability: KzmCalAvailability.create({
                url: myself.data("avail-url"),
                path: "blocked",
                params: {},      // `n` is a legacy flag, on the old endpoint only
                timeSuffix: "",  // this one takes bare Y-m-d
            }),
            // The original fetched one eager window: two months before the
            // preselection through `availabilityRange` months after it, 8 on
            // desktop and 14 on mobile. Mirror it so paging never has to wait.
            availabilityPadding: { before: 2, after: ismobile ? 14 : 8 },
            availabilityInitialSpan: ismobile ? 14 : 8,
            initialRange: initialRange
        });

        // KzmCal derives its column count from the month count. Mobile wants
        // six months stacked two-up (one-up below 768px), so override it.
        if (ismobile) {
            cal.on("render", function (e) {
                $(e.container).find(".js-easypicker-wrapper")
                    .css("--ep-cals", String(gridNr));
            });
            mountEl.find(".js-easypicker-wrapper").css("--ep-cals", String(gridNr));
        }

        /* ----- price recalculation ------------------------------------ */
        /*
         * Kept close to the original. The one structural change: the original
         * shared a single `isLoading` flag between this and the availability
         * fetch, so an availability request in flight would silently swallow a
         * price recalc. Availability is KzmCal's business now and carries its
         * own ref-counted lock, so this only has to guard itself.
         */
        var recalcUrl = myself.data("recalc-url");
        var recalcTarget = $(myself.data("recalc-target"));
        var watchlistTarget = $(myself.data("watchlist-target"));
        var bookingBox = myself.closest(".sticky-box");
        var form = myself.closest("form");
        var personsTarget = form.find('input[name="persons"]');
        if (personsTarget.length <= 0) {
            personsTarget = bookingBox.find('input[name="persons"]');
        }
        // The site's own overlay, not KzmCal's `.is-loading`. It covers the
        // booking box and the price panel, which the calendar cannot reach.
        var overlay = $(".easypick-loading-overlay");
        var isRecalcLoading = false;

        var loadNewPrice = function (fromIso, toIso, persons) {
            if (!recalcUrl || isRecalcLoading) {
                return;
            }
            var fromString = fromIso ? formatHidden(fromIso) : dateFromHiddenEl.val();
            var toString = toIso ? formatHidden(toIso) : dateToHiddenEl.val();
            if (persons === undefined || persons === null) {
                persons = personsTarget.val();
            }

            overlay.show();
            isRecalcLoading = true;

            var req = $.ajax(recalcUrl, {
                type: "POST",
                data: { from: fromString, to: toString, persons: persons, n: "1" },
                dataType: "JSON"
            }).then(function (response) {
                if (response && response.success) {
                    recalcTarget.html(response.html);
                    // The recalc response carries a fresh watchlist button —
                    // its data-from/data-to are what the watchlist posts.
                    var watchlistData = recalcTarget.find(".watchlist-data");
                    if (watchlistTarget.length > 0) {
                        watchlistTarget.html(watchlistData.html());
                    }
                    if (bookingBox.length > 0) {
                        recalcTarget.find('[data-toggle="tooltip"]').tooltip();
                    }
                    var paymentSummaryModal = $("#paymentSummaryModal");
                    if (paymentSummaryModal.length > 0) {
                        paymentSummaryModal.find(".payment-summary-content")
                            .html(response.paymentSummary);
                    }
                }
            }).catch(function () {
                console.error.apply(console, arguments);
            }).always(function () {
                isRecalcLoading = false;
                overlay.hide();
            });

            // Lock the calendar for as long as the price is in flight, so the
            // user cannot pick a second range on top of a pending one.
            cal.holdBusy(Promise.resolve(req).catch(function () {}), "recalc");
        };

        /*
         * The server preselects "tomorrow + 31 nights" without consulting
         * availability, so the range regularly lands inside a booking — on this
         * object it currently does. easepick applied it anyway and drew a
         * selection across struck-through days; KzmCal refuses, which is the
         * behaviour we want. Drop it from the fields too, so the calendar and
         * the inputs cannot disagree, and leave the page's own "already rented"
         * message to explain it.
         */
        /*
         * KzmCal applies a valid initialRange by way of an ordinary `select`,
         * so the first one has to be told apart from a real user pick: the
         * original suppressed the price call, the history push and the focus
         * handover on init (`omitNewPrice` / `omitGotoCal` in handlePreSelection).
         */
        var pendingInitialSelect = !!initialRange;

        /*
         * A failed availability fetch fails *open* — the grid keeps whatever it
         * has, which on the first fetch is nothing at all, and every day looks
         * bookable. Nothing else listens for this, so a wrong `data-avail-url`
         * or a renamed field would be silent.
         */
        cal.on("availability:error", function (d) {
            console.error("detail-calendar: availability fetch failed, the grid may show blocked days as free —", d.error);
        });

        cal.on("initialrange:rejected", function (d) {
            pendingInitialSelect = false;
            console.warn("detail-calendar: server preselection is not bookable —", d.reason);
            clearDateFromEls();
            clearDateToEls();
            nightsCont.hide();
            updateSomeInfo();
        });

        /* ----- scrolling ---------------------------------------------- */
        var scrollToCalendar = function () {
            if (ismobile || scrollToBlock.length <= 0) {
                return;
            }
            $("html, body").animate({
                scrollTop: scrollToBlock.offset().top - SCROLL_BLOCK_OFFSET
            }, 300);
        };

        // KzmCal puts first-available on `.day` itself; easepick had it on the
        // inner `.border-radius`.
        var scrollToDay = function (selector) {
            if (!ismobile) {
                return;
            }
            var pullup = $(".portal-search-mobile-pullup").eq(0);
            if (pullup.length <= 0) {
                return;
            }
            var jumpEl = mountEl.find(selector).first();
            if (jumpEl.length > 0) {
                pullup.animate({
                    scrollTop: (jumpEl.offset().top - pullup.offset().top) +
                        pullup.scrollTop() - MOBILE_JUMP_OFFSET
                }, 500);
            } else {
                pullup.animate({ scrollTop: 0 }, 500);
            }
        };

        /* ----- events ------------------------------------------------- */
        cal.on("preselect", function (d) {
            setDateFromEls(d.start);
            clearDateToEls();
            nightsCont.hide();
            updateSomeInfo();
            if (ismobile) {
                scrollToDay(".day.first-available");
            } else {
                cal.gotoDate(d.start);
            }
            // …then hands the user over to the check-out field.
            dateToEl.trigger("click");
        });

        cal.on("select", function (d) {
            setDateFromEls(d.start);
            setDateToEls(d.end);
            nightsEl.text(d.nights);
            nightsCont.show();
            updateSomeInfo();

            if (pendingInitialSelect) {
                // Applying what the server already rendered. The price panel is
                // already correct for these dates and the URL already carries
                // them, so touching either would be a wasted round trip.
                pendingInitialSelect = false;
                return;
            }

            updateUrlParams({
                from: formatHidden(d.start),
                to: formatHidden(d.end)
            }, { replace: true });
            loadNewPrice(d.start, d.end);

            // A complete range puts the highlight back on the check-in field
            // and drops the chrome's focus styling.
            dateFromEl.trigger("focus");
            myself.removeClass("gray");
            myself.find(".content-search-fromto, .portal-search-fromto").removeClass("white");
        });

        cal.on("clear", function (d) {
            if (d.what === "all") {
                clearDateFromEls();
            }
            clearDateToEls();
            nightsCont.hide();
            updateSomeInfo();
        });

        /* ----- field wiring ------------------------------------------- */
        // Click, not focus: the fields are readonly so a click focuses them
        // natively, and the chrome's own `.form-control` focus handler still
        // gets to run for the gray/white styling.
        dateFromEl.on("click", function () {
            scrollToCalendar();
            cal.setMode("from");
            if (currDateFrom) {
                cal.gotoDate(currDateFrom);
                scrollToDay(".day.start");
            }
            $(this).trigger("focus");
        });
        dateToEl.on("click", function (e) {
            e.preventDefault();
            // Original behaviour: no check-in yet means the user is in the
            // wrong field — send them to the check-in one instead.
            if (!currDateFrom) {
                dateFromCloseEl.trigger("click");
                return false;
            }
            scrollToCalendar();
            cal.setMode("to");
            if (currDateTo) {
                cal.gotoDate(currDateTo);
                scrollToDay(".day.end");
            } else {
                scrollToDay(".day.first-available");
            }
            $(this).trigger("focus");
        });

        dateFromCloseEl.on("click", function () {
            cal.clear();
            dateFromEl.trigger("click");
        });
        dateToCloseEl.on("click", function () {
            // clearEnd keeps the check-in and drops back into check-out mode.
            cal.clearEnd();
            if (cal.getStartDate()) {
                dateToEl.trigger("click");
            } else {
                dateFromEl.trigger("click");
            }
        });

        /* ----- persons ------------------------------------------------ */
        personsTarget.on("change", function () {
            var personsValue = $(this).val();
            loadNewPrice(null, null, personsValue);
            updateUrlParams({
                from: dateFromHiddenEl.val(),
                to: dateToHiddenEl.val(),
                persons: personsValue
            }, { replace: true });
        });

        myself.data("kzmCal", cal);
    });
}

function updateUrlParams(params, options) {
    var replace = !!(options && options.replace);
    var url = new URL(window.location.href); // keeps path + hash
    Object.keys(params).forEach(function (key) {
        var value = params[key];
        if (value === null || value === undefined || value === "") {
            url.searchParams.delete(key);
        } else {
            url.searchParams.set(key, String(value));
        }
    });
    history[replace ? "replaceState" : "pushState"]({}, "", url);
}

/* ========================================================================
 * Booking-box chrome — unchanged from current_src/detail-search-bar-old.js
 * except where noted
 * ====================================================================== */

export function initInScope ($scope) {
    // `stickyBoxContainer`, `fixmeTop`, `slInput` and `firstClick` below are all
    // dead — declared, never read. Kept so this stays a pure restore of the
    // original. Worth knowing that `fromToWrapper.offset()` is undefined when the
    // page has no `.mobile-search-fromto-wrapper`, so `fixmeTop` would throw
    // there; the detail page always has one.
    let stickyBoxContainer = $scope.find(".detail-search-box ");
    let dtContainer = $scope.find(".content-search-box ");
    dtContainer.find(".form-control").each(function (e) {
        $(this).on("focus", function (e) {
            // console.log("FOCUSING, doing GRAY stuff");
            dtContainer.addClass("gray");
            let allFormGroups = dtContainer.find(".form-group-inline");
            allFormGroups.removeClass("white");
            allFormGroups.removeClass("nodashed-border");

            let closestFormGroup = $(this).closest(".form-group-inline");
            let thisIndex = allFormGroups.index(closestFormGroup[0]);

            allFormGroups.each(function (i, e) {
                if(i === thisIndex - 1) {
                    $(this).addClass("nodashed-border");
                }
            });
            let parent = $(this).parents(".form-group-inline:first")
            parent.addClass("white");
        });
    });
    // stickyBoxContainer.on("change", function (e) {
    //     window.loadNewPrice();
    // });


    let pullup = $(".portal-search-mobile-pullup");
    let fromToWrapper = pullup.find('.mobile-search-fromto-wrapper');
    // var fromToWrapper = pullup.find('.js-easypicker-container');
    let fixmeTop = fromToWrapper.offset().top;
    let slInput = pullup.find("#search-location .js-places-autocomplete.tt-input");
    let firstClick = true;
    let stickyMobile = $(".objekt-detail-sticky");
    // console.log("-----------------pullup");
    // console.log(pullup);
    function closePullup() {
        $("body").removeClass("modal-open");
        pullup.removeClass("open");
        // let the hash router remove the history entry (replaceState only relabels
        // it, which strands a dead back press)
        closeEntry('pullup');
    }
    stickyMobile.on("click", ".js-change-data", function (e) {
        e.preventDefault();
        if(pullup.hasClass("open")) {
            closePullup()
        } else {
            _config.hashStack.push('pullup');
            history.pushState({ hashStack: _config.hashStack }, '', '#pullup');
            $("body").addClass("modal-open");
            pullup.addClass("open");
            if($("#search-fromto").hasClass("show")) {
                $("#search-fromto").removeClass("show");
            }
        }
        return false;
    });
    $(".portal-search-mobile-pullup .portal-search-close").on("click", function (e) {
        closePullup();
        return false;
    });

    $scope.find(".portal-search__person-select").each(function () {
        let dummyEl = $(this).parent().find("input.dummy");
        let hiddenInputEl = $(this).parent().find("input.persons-hidden");
        let personsLocale = $(this).data("locale");
        let personLocale = $(this).data("locales");
        let personInput = $(this).find("input");
        let minPersons = $(this).data("min");
        let maxPersons = $(this).data("max");
        $(this).find(".add").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value < maxPersons) {
                personInput.val(value + 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
            if(personInput.val() > 0) {
                $('.js-object-detail-persons-error').attr('hidden',true);
            }
        });
        $(this).find(".sub").on("click", function (e) {
            let value = personInput.val() ? parseInt(personInput.val()) : 0;
            if(value > minPersons) {
                personInput.val(value - 1);
                hiddenInputEl.val(personInput.val());
                if(personInput.val() <= 1) {
                    dummyEl.val(personInput.val() + " " + personLocale);
                } else {
                    dummyEl.val(personInput.val() + " " + personsLocale);
                }
                personInput.trigger("change");
            }
            if(personInput.val() > 0) {
                $('.js-object-detail-persons-error').attr('hidden',true);
            }
        });
    });
    /*
     * Delegated on $scope, not bound to the elements — which is what lets it keep
     * working after the calendar's loadNewPrice() replaces the whole of
     * `#booking-box-price`, where `.price-type` lives. Leave it delegated.
     */
    $scope.on("click", ".price-type", function(e) {
        // console.log("clicking pricetype");
        e.preventDefault();
        let type = $(this).data("target");
        let totalEl = $scope.find(".price.total");
        let monthEl = $scope.find(".price.month");
        $scope.find(".price-type").removeClass("active");
        if(type === "month") {
            totalEl.hide();
            monthEl.show();
        } else {
            monthEl.hide();
            totalEl.show();
        }

        $(this).addClass("active");
        return false;
    });

    // Was easy-pick-blocked.js, loaded as its own module. Runs last so the
    // chrome's handlers are bound before the pickers start firing events — the
    // calendar's `select` focuses the check-in field and then strips the
    // gray/white highlight the focus handler above applies.
    initCalendars($scope);
}
